import React, { useMemo } from "react";

const InputCheckBoxes = (props) => {
	const onChange = (value, isChecked) => {
		!isChecked
			? props.setValue([...props.value, value])
			: props.setValue(props.value.filter((val) => val !== value));
	};

	return (
		<div className="row">
			{useMemo(() =>
				props.valueList.map(
					(v, i) => {
						const isChecked = props.value.filter((val) => val === v.value).length > 0;
						const id = `checkbox--${v.key}-${v.value}`;
						return (
							<div className="col-4" key={i}>
								<div className="custom-control custom-checkbox mb-1">
									<input
										className="custom-control-input"
										type="checkbox"
										id={id}
										checked={isChecked}
										value={v.value}
										onChange={() => onChange(v.value, isChecked)}
									/>
									<label className="custom-control-label" htmlFor={id}>
										{v.key}
									</label>
								</div>
							</div>
						);
					},
					[props.value]
				)
			)}
		</div>
	);
};

InputCheckBoxes.defaultProps = {
	value: [],
	valueList: [],
};

export default InputCheckBoxes;
